import { useSelector } from "react-redux";
import RequestItemsList from "go-component/components/RequestItem/RequestItemsList";
import { selectOrganization } from "go-security/services/organizations/selectors";

const OrganizationLogsRequestItemsIndexPage = () => {
	const organization = useSelector(selectOrganization);
	return <RequestItemsList organization_name={organization?.name ?? ""} />;
};

export default OrganizationLogsRequestItemsIndexPage;
